import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVolumeMute, faVolumeUp} from "@fortawesome/free-solid-svg-icons";

const SoundIcon = props => {
  const {displayAudio, sound, onToggleSound} = props;
  if (!displayAudio) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={sound ? faVolumeUp : faVolumeMute}
      className={'icon-sound '}
      onClick={onToggleSound}
    />
  );
}

export default SoundIcon;
